import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

export const DoubleClickLinkPlugin = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        // Get the editor's root element
        const editorRootElement = editor.getRootElement();
        if (!editorRootElement) return null;

        // Handler for double-click events
        const handleDoubleClick = (event: MouseEvent) => {
            // Check if the clicked element or any of its parents is an anchor tag
            let target = event.target as HTMLElement | null;
            
            while (target && target !== editorRootElement) {
                if (target.tagName === 'A') {
                    event.preventDefault();
                    const href = target.getAttribute('href');
                    if (href) {
                        window.open(href, '_blank');
                    }
                    break;
                }
                target = target.parentElement;
            }
        };

        // Add event listener for double-click
        editorRootElement.addEventListener('dblclick', handleDoubleClick);

        // Clean up the event listener when the component unmounts
        return () => {
            editorRootElement.removeEventListener('dblclick', handleDoubleClick);
        };
    }, [editor]);

    return null;
};
